import { render, staticRenderFns } from "./DateRangeExt.vue?vue&type=template&id=5afad80d&scoped=true&"
import script from "./DateRangeExt.vue?vue&type=script&lang=js&"
export * from "./DateRangeExt.vue?vue&type=script&lang=js&"
import style0 from "./DateRangeExt.vue?vue&type=style&index=0&id=5afad80d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5afad80d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5afad80d')) {
      api.createRecord('5afad80d', component.options)
    } else {
      api.reload('5afad80d', component.options)
    }
    module.hot.accept("./DateRangeExt.vue?vue&type=template&id=5afad80d&scoped=true&", function () {
      api.rerender('5afad80d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2CkMrdItJoh90/JS/comp/DateRangeExt.vue"
export default component.exports